import { Component, OnInit, Input, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

import { TranslateService } from '@ngx-translate/core';

@Component({

    selector: 'aFormRadioLang,[aFormRadioLang]',
    templateUrl: './aFormRadioLang.component.html',
    styleUrls: ['./aFormRadioLang.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormRadioLangComponent, multi: true },
    ]
})
export class AFormRadioLangComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    options;
    value;
    temp;
    _onChange = (value: any) => { };
    onChange(value: any) {

        if (value == "") {
            this.value = null;
            this.temp = '';
            this._onChange(null);
        } else {
            this.value = { _id: +value };
            this.temp = value;
            this._onChange(this.value);
        }

    };


    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this.value = value;
    }

    constructor(public rootService: RootService, private translate: TranslateService) {
        this.temp = "";

    }

    ngOnInit() {
        this.translate.get(this.id + '.options').subscribe((options) => {
            this.options = options;
        });
        this.translate.onLangChange.subscribe(event => {
            this.translate.get(this.id + '.options').subscribe((options) => {
                this.options = options;
            });
        })

    }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormRadioLang/aFormRadioLang.component.ts